function e(e){return e?e.charAt(0).toUpperCase()+e.slice(1).toLowerCase():e}export{e as upFirstLetter};
